import { DiscountStatusCard as AntdDiscountStatusCard } from "@empglabs/backoffice-ui-kit"

const DiscountStatusCard = props => {
  return <AntdDiscountStatusCard {...props} />
}

export default DiscountStatusCard
